import request from '@/utils/request'

//会话
export function engineQuery(data) {
    return request({
        url: '/api/engine/query',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

export function apiCheckSession(data) {
    return request({
        url: 'api/engine/checkSession',
        method: 'post',
        // 点击刷新不加载
        quiet: true,
        headers:{
            showLoading:false  

        },
        data
    })
}

//保存对话
export function engineSavedialog(data) {
    return request({
        url: '/api/engine/savedialog',
        method: 'post',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        data
    })
}
//历史对话列表
export function engineGetdialoglist(data) {
    return request({
        url: '/api/engine/getdialoglist',
        method: 'get',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        params:data
    })
}
//详细对话流
export function engineGetdialog(data) {
    return request({
        url: '/api/engine/getdialog',
        method: 'get',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        params:data
    })
}
// 删除对话
export function engineDeldialog(data) {
    return request({
        url: '/api/engine/deldialog',
        method: 'get',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        params:data
    })
}


// suno
export function apiCreateSuno(data) {
    return request({
        url: '/api/engine/createSuno',
        method: 'post',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        quiet: true,
        data
    })
}

export function apiFetchSuno(data) {
    return request({
        url: '/api/engine/fetchSuno',
        method: 'post',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        data
    })
}

// 首页示例
export function apiGetExamples(data) {
    return request({
        url: '/api/engine/getExamples',
        method: 'post',
        // 点击刷新不加载
        headers:{
            showLoading:false  

        },
        data
    })
}